import api from '../index'

export interface Product {
  id: number
  name: string
  desc?: string
  description?: string
  content?: string
  thumbnail?: string
  carousel?: string[]
  icon?: string
  version?: string
  status: 'developing' | 'released' | 'maintained' | 'deprecated'
  tags?: string[]
  sort?: number
  created_at: string
  updated_at: string
}

export interface ProductCreateData {
  name: string
  desc?: string
  description?: string
  content?: string
  thumbnail?: string
  carousel?: string[]
  icon?: string
  version?: string
  status: 'developing' | 'released' | 'maintained' | 'deprecated'
  tags?: string[]
  sort?: number
}

export interface ProductUpdateData {
  name?: string
  desc?: string
  description?: string
  content?: string
  thumbnail?: string
  carousel?: string[]
  icon?: string
  version?: string
  status?: 'developing' | 'released' | 'maintained' | 'deprecated'
  tags?: string[]
  sort?: number
}

export interface ProductListParams {
  page?: number
  pageSize?: number
  keyword?: string
  status?: string
}

export const productApi = {
  // 获取产品列表
  list: (params?: ProductListParams) => api.get('product/list', { params }),

  // 获取产品详情
  detail: (id: number) => api.get(`product/${id}`),

  // 创建产品
  create: (data: ProductCreateData) => api.post('product', data),

  // 更新产品
  update: (id: number, data: ProductUpdateData) => api.put(`product/${id}`, data),

  // 删除产品
  delete: (id: number) => api.delete(`product/${id}`),
}

export default productApi
